import { ContactUs } from "@App/Components/ContactUs";
import { Hero } from "@App/Components/Hero";
import { VehicleReturnContractStepDefinition } from "@App/Components/molecules/whitelabel/home/stepDefinitions/VehicleReturnContractStepDefinition";
import { Step } from "@App/Components/Stepper/Step";
import { Stepper } from "@App/Components/Stepper/Stepper";
import { TriangleDivider } from "@App/Components/TriangleDivider";
import { useServices } from "@App/hooks/api/useServices";
import { useHome } from "@App/hooks/useHome";
import { useVehicleReturnContractStepDefinition } from "@App/hooks/whitelabel/home/stepper/useVehicleReturnContractStepDefinition";
import { ServiceStep } from "@App/Pages/Partner/Partials/ServiceStep";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";
import { Fragment, type FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

export type HomeProps = {
  embedded?: boolean;
  onSubmit: () => void;
};

export const Home: FunctionComponent<HomeProps> = ({ embedded = false, onSubmit }: HomeProps) => {
  const { t } = useTranslation();

  // step definitions
  const contractDataStepProps = useVehicleReturnContractStepDefinition(onSubmit);

  const { loading, error, services } = useServices();

  const { currentStep, setCurrentStep, organization, service, selectService } = useHome();

  useEffect(() => {
    if (currentStep === 0 && service) {
      selectService(service, true);
    }
  }, [service, currentStep]);

  return (
    <Fragment>
      <Hero
        organization={organization}
        title={t("hero.title", { organization: organization?.name })}
        subtitle={t("hero.subtitle", {
          organization: organization?.name,
        })}
        backgroundImage={
          organization?.settings?.hero.background_image_url ??
          "/images/brand/arval-banner-darkened.jpg"
        }
      />
      <div className="bg-white px-5 pt-5 container">
        <Stepper currentStep={currentStep} onChange={setCurrentStep}>
          <Step
            title={t("Waehlen Sie einen Service.")}
            subtitle={service?.pivot.subtitle ? service.pivot.subtitle : null}
            completedTitle={"Service: "}
            completedGoBackLinkTitle={
              service
                ? service.pivot.display_name
                  ? service.pivot.display_name
                  : service.name
                : ""
            }
          >
            <ServiceStep
              service={service}
              services={services}
              loading={loading}
              error={error}
              selectService={selectService}
              organization={organization}
            />
          </Step>
          {ServiceIsVehicleReturn(service) && (
            <VehicleReturnContractStepDefinition {...contractDataStepProps} />
          )}
        </Stepper>
      </div>
      {!embedded && (
        <div className="bg-neutral-100">
          <TriangleDivider direction="left" background={"bg-white"} />
          <div className="px-5 py-5 container md:pb-20">
            <div className="md:grid md:grid-cols-[50%_50%]">
              <div className="pt-5 md:pt-0 md:ml-12">
                <ContactUs />
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
